import { Button, Id, Loading, isSuccess } from "@dgs/core";
import { FC, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
	entityId: Id;
	markAsPrimary: (id: Id) => Promise<any>;
	onSubmit: () => void;
}
export const MarkAsPrimaryButton: FC<Props> = ({ entityId, markAsPrimary, onSubmit }) => {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState(false);

	const onClick = useCallback(async () => {
		try {
			setIsLoading(true);
			const res = await markAsPrimary(entityId);
			isSuccess(res) && onSubmit();
		} finally {
			setIsLoading(false);
		}
	}, [markAsPrimary, entityId, onSubmit]);

	return (
		<Button type="button" onClick={onClick} prefix={isLoading && <Loading variant="tiny" />}>
			{t("Mark as primary")}
		</Button>
	);
};
